import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToForm = () => {
    const el = document.getElementById('contact-form');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-[#000000] overflow-hidden" data-id="element-166">
      {/* Mobile: Image on top */}
      <div className="block lg:hidden w-full h-[55vh] relative" data-id="element-167">
        <img src="https://cdn.magicpatterns.com/uploads/14yCURBiYUbxj3UBKMC9ME/heylloyd-image-1773459428240.png" alt="Técnico HVAC profesional realizando diagnóstico de aire acondicionado" className="w-full h-full object-cover object-top" data-id="element-168" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#000000]" data-id="element-169"></div>
      </div>

      {/* Desktop: Split layout */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-170">
        <div className="flex flex-col lg:flex-row items-center lg:min-h-[85vh]" data-id="element-171">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 py-10 lg:py-20 lg:pr-12" data-id="element-172">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} data-id="element-173">
              <div className="inline-block mb-6 px-4 py-1.5 border border-[#50C878]/50 bg-[#50C878]/10 rounded-full shadow-[0_0_15px_rgba(80,200,120,0.2)]" data-id="element-174">
                <span className="text-[#50C878] font-bold text-xs sm:text-sm tracking-wider uppercase" data-id="element-175">
                  🩺 SISTEMA DE ADQUISICIÓN ÉLITE — DOCTOR ECOMMERCE
                </span>
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] xl:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-176">
                Tu negocio de HVAC tiene un{' '}
                <span className="text-[#FFD700] drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]" data-id="element-177">
                  soplo en el corazón
                </span>
                :{' '}
                <span className="text-[#FFD700] drop-shadow-[0_0_10px_rgba(255,215,0,0.3)]" data-id="element-178">
                  No genera llamadas.
                </span>{' '}
                🩺❄️
              </h1>

              <p className="text-base sm:text-lg md:text-xl text-[#C0C0C0] mb-8 max-w-2xl leading-relaxed" data-id="element-179">
                Dejamos de jugar con "likes". Inyectamos{' '}
                <span className="text-white font-bold" data-id="element-180">Leads Reales</span>{' '}
                directo a tu teléfono. Sistema de Adquisición Élite por Doctor
                Ecommerce.
              </p>

              <motion.button onClick={scrollToForm} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="w-full sm:w-auto bg-[#FFD700] text-black font-black text-base sm:text-lg md:text-xl px-6 sm:px-8 py-4 rounded-lg neon-glow transition-all duration-300 flex items-center justify-center gap-2 uppercase tracking-wide" data-id="element-181">
                PRESCRIPCIÓN: OBTENER MI DIAGNÓSTICO GRATIS
                <ArrowDownIcon className="w-6 h-6" data-id="element-182" />
              </motion.button>

              <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4" data-id="element-183">
                <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-[#50C878] hover:text-white underline text-sm font-bold transition-colors" data-id="element-184">
                  O agenda directamente en nuestro calendario →
                </a>
                <p className="text-sm text-[#C0C0C0] flex items-center gap-2 font-medium" data-id="element-185">
                  <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-186"></span>
                  Cupos limitados este mes.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Desktop: Image on right */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1,
          delay: 0.3
        }} className="hidden lg:block w-1/2 relative" data-id="element-187">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(80,200,120,0.15)] border border-[#50C878]/20" data-id="element-188">
              <img src="https://cdn.magicpatterns.com/uploads/14yCURBiYUbxj3UBKMC9ME/heylloyd-image-1773459428240.png" alt="Técnico HVAC profesional realizando diagnóstico de aire acondicionado" className="w-full h-[75vh] object-cover object-top" data-id="element-189" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/60 via-transparent to-transparent" data-id="element-190"></div>
              {/* Green accent corner */}
              <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#50C878] via-[#50C878]/50 to-transparent" data-id="element-191"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}